
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-transition",
      function () {
        return require("private-next-pages/use-transition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-transition"])
      });
    }
  